
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Metric } from 'web-vitals';
import { loadDeferredScripts } from './utils/deferredScripts';

// Optimize performance monitoring but don't log to console
const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    // Use dynamic import for web-vitals to reduce initial bundle size
    import('web-vitals').then(({ onCLS, onFID, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onFID(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

// Create the root with specific options to improve CLS
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

// Use createRoot with concurrent mode for better performance
const root = ReactDOM.createRoot(rootElement);

// Render with React Strict Mode disabled in production to avoid double-rendering
const StrictModeWrapper = import.meta.env.DEV 
  ? React.StrictMode
  : React.Fragment;

root.render(
  <StrictModeWrapper>
    <BrowserRouter>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </BrowserRouter>
  </StrictModeWrapper>
);

// Load deferred analytics scripts to improve initial page load performance
loadDeferredScripts();

// Only collect performance metrics in production but don't log to console
if (import.meta.env.PROD) {
  reportWebVitals();
}
